import { trpc, trpcUnbatchedClient } from '@/api/trpc';
import { fetchStrategyReadinessSummaries } from '@/api/strategyReadinessBatch';
import { DEFAULT_REQUISITIES_STALE_TIME } from '@/config/constants';
import { useAppQuery } from '@/hooks/useAppQuery';

export function useStrategyReadinessSummaries(strategyIds: number[], options: { enabled?: boolean; fallbackErrorMessage: string }) {
    return useAppQuery(
        {
            ...trpc.strategyReadiness.getReadinessSummaryBatch.queryOptions({ strategyIds }),
            queryFn: ({ signal }) =>
                fetchStrategyReadinessSummaries(strategyIds, (input) =>
                    trpcUnbatchedClient.strategyReadiness.getReadinessSummaryBatch.query(input, { signal })
                ),
            staleTime: DEFAULT_REQUISITIES_STALE_TIME,
            enabled: strategyIds.length > 0 && (options.enabled ?? true)
        },
        {
            fallbackErrorMessage: options.fallbackErrorMessage,
            showErrorToast: true
        }
    );
}
